<script setup>
import { onMounted, ref } from "vue";
import { FilterMatchMode, FilterOperator } from '@primevue/core/api';
import { pVentasRequest, findAllRequest } from '../api/invoices';
import { branchOfficeRequest, productsRequest } from '../api/statistics';
import BarChart from '../components/Charts/exampleChart.vue'
import { invocer } from '../api/invoicer';
import { municipality } from '../api/technicalAnnex';

import Select from 'primevue/select';
import DatePicker from 'primevue/datepicker';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
const { format, subDays } = require("date-fns");


// Fecha actual
const today = new Date();
const formattedToday = format(today, "MM/dd/yyyy");

// Fecha del día anterior
const yesterday = subDays(today, 1);
const formattedYesterday = format(yesterday, "MM/dd/yyyy");
const filters = ref();
const initFilters = () => {
  filters.value = {
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    nombre: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    nombre_archivo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    consecutivo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    totalFactura: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
  };
}

initFilters();
const dataSource = ref([]);
const invoicerSouce = ref([]);
const pventas = ref([]);
const selectedPventa = ref('');
const branchOffice = ref([]);
const productsData = ref([]);

const data_from = ref(formattedYesterday);
const data_to = ref(formattedToday);
const activeSpinner = ref(false)
const selectedInvoicer = ref(null);
const selectedBranchOffice = ref(null);
const selectedPventas = ref(null);
const selectedProduct = ref(null);

//ObjetsArray Municipios && Departamentos
const munDep = ref([]);
const municipalities = ref([]);
const departments = ref([]);
const selectedDeparment = ref(null);
const selectedCodeDeparment = ref(null);
const selectedMunicipaly = ref(null);
const selectedCodeMunicipaly = ref(null);


//Charts Variables

//Top 10 - Productos + Vendidos
const labelsBestSelling = ref(['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange']);
const dataBestSelling = ref([12, 19, 3, 5, 2, 3]);


const formatDate = (date) => {
  if (date != undefined) {
    const fecha = new Date(date);
    return format(fecha, "yyyy-MM-dd");
  } else {
    return null;
  }
}

const resetFilter = () => {
  data_from.value = null;
  data_to.value = null;
  selectedPventa.value = '';
  selectedInvoicer.value = null;
  selectedDeparment.value = null;
  selectedCodeDeparment.value = null;
  selectedMunicipaly.value = null;
  selectedCodeMunicipaly.value = null;
  selectedBranchOffice.value = null;
  loadInfo();
}

const loadInfo = () => {
  const date_from = formatDate(data_from.value);
  const date_to = formatDate(data_to.value);
  let data = {
    date_from,
    date_to,
    pventa: selectedPventa.value,
    invoicer: selectedInvoicer.value
  }
  loadInvoices(data);
  loadNameByPventa();
}

//sucursales
const loadNameByPventa = async () => {
  try {
    let data = {
      department: selectedCodeDeparment.value,
      municipality: selectedCodeMunicipaly.value,
      branchOffice: selectedBranchOffice.value
    }
    let result = await pVentasRequest(data)
    pventas.value = result.data.data;
  } catch (error) {
    console.log(error);
  }
}

const loadMucipaly = async () => {
  let municipalitiesAndDepartments = await municipality();
  munDep.value = municipalitiesAndDepartments.data.data;
  department();
}

const loadInvoices = async (data) => {
  activeSpinner.value = true;
  try {
    let result = await findAllRequest(data);
    dataSource.value = result.data.data;
    activeSpinner.value = false;
  } catch (error) {
    console.log(error);
  }
}

const sourceInvoicer = async () => {
  const invoicers = await invocer();
  invoicerSouce.value = invoicers.data.data;
}

const department = () => {
  departments.value = munDep.value.reduce((acc, curr) => {
    const existing = acc.find(item => item.departamento === curr.nombre_departamento);
    return existing ? acc : [...acc, { codigo: curr.codigo_departamento, departamento: curr.nombre_departamento }];
  }, []);
}

const municipalityAndCode = () => {
  selectedCodeDept();
  selectedCodeMunicipaly.value = null;
  municipalities.value = [];
  const code = selectedCodeDeparment.value
  municipalities.value = munDep.value
    .filter(item => item.codigo_departamento === code)
    .map(item => ({
      codigo: item.codigo_municipio,
      municipio: item.nombre_municipio
    }));
}

const selectedCodeDept = () => {
  let code = selectedDeparment.value.codigo != undefined ? selectedDeparment.value.codigo : selectedDeparment.value;
  selectedCodeDeparment.value = code
}

const selectedCodeMun = () => {
  let code = selectedMunicipaly.value.codigo != undefined ? selectedMunicipaly.value.codigo : selectedMunicipaly.value;
  selectedCodeMunicipaly.value = code;
  loadNameByPventa(); //load sucursales
}

const loadBranchOffices = async () => {
  const invoicer = selectedInvoicer.value
  try {
    let result = await branchOfficeRequest({ invoicer });
    branchOffice.value = result.data.data;
  } catch (error) {
    console.log(error);
  }
}

const loadProducts = async () => {
  const date_from = formatDate(data_from.value);
  const date_to = formatDate(data_to.value);
  let data = {
    pventa: selectedBranchOffice.value,
    date_from,
    date_to,
    codeMunicipaly: selectedCodeDeparment.value,
    codeDepartment: selectedCodeMunicipaly.value,
    invoicer: selectedInvoicer.value
  }
  try {
    let result = await productsRequest(data);
    productsData.value = result.data.data;
  } catch (error) {
    console.log(error);
  }
}

onMounted(() => {
  loadNameByPventa();
  loadInfo();
  sourceInvoicer();
  loadMucipaly();
  loadProducts()
});

</script>
<template>
  <div class="py-4 container-fluid">
    <Toast />
    <ConfirmDialog></ConfirmDialog>
    <div class="d-flex justify-content-center align-content-center">
      <div class="col-lg-12 col-md-6 col-12">
        <div class="mb-3 card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label for="selectedDeparment" class="form-label">Departamento</label>
                <Select v-model="selectedDeparment" @change="municipalityAndCode(), loadProducts()" :options="departments" filter
                  optionLabel="departamento" class="form-select form-select-sm" />
              </div>
              <div class="col-md-3">
                <label for="selectedMunicipaly" class="form-label">Municipio</label>
                <Select v-model="selectedMunicipaly" @change="selectedCodeMun(), loadProducts()" :options="municipalities" filter
                  optionLabel="municipio" class="form-select form-select-sm" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Fecha Inicio</label><br>
                <DatePicker class="input" v-model="data_from" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Fecha Final</label><br>
                <DatePicker class="input" v-model="data_to" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Facturador</label><br>
                <Select v-model="selectedInvoicer" :options="invoicerSouce" filter optionValue="id_facturador"
                  optionLabel="razon_social" class="form-select form-select-sm"
                  @change="loadInfo(), loadBranchOffices()" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Puntos de Venta</label><br>
                <Select v-model="selectedBranchOffice" :options="branchOffice" filter optionValue="nombre"
                  optionLabel="nombre" class="form-select form-select-sm" @change="loadInfo" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Sucursales</label>
                <Select v-model="selectedPventas" @change="loadProducts" :options="pventas" filter optionValue="nombre"
                  optionLabel="nombre" class="form-select form-select-sm" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Productos</label>
                <Select v-model="selectedProduct" :options="productsData" filter optionValue="product"
                  optionLabel="product" class="form-select form-select-sm" />
              </div>
              <div class="col-md-3">
                <button class="btn btn-link mt-4 py-3" @click="loadInfo">
                  <i class="fa fa-search" aria-hidden="true" />
                </button>
                <button class="btn btn-link mt-4 py-3" @click="resetFilter">
                  <i class="fa fa-broom" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card z-index-2">
      <div class="col-lg-12 mb-lg-0 mb-4">
        <div class="card">
          <div class="mt-3 px-2">
            <div class="row">
              <div class="col-6 col-md-4">
                <div class="card">
                  <div class="card-header">Top 10 - Productos + Vendidos</div>
                  <div class="card-body">
                    <BarChart 
                      id="barChart"
                      height="400"
                      :chart="{
                        labels: labelsBestSelling,
                        datasets: [
                          {
                            label: 'Total De Venta',
                            data: dataBestSelling,
                          },
                        ]
                      }" 
                    />
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="card">
                  <div class="card-header">Sucursales Con Mayores Ventas</div>
                  <div class="card-body">

                  </div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="card">
                  <div class="card-header">Total Ventas Por Punto</div>
                  <div class="card-body">

                  </div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="card">
                  <div class="card-header">Total Por Municipio</div>
                  <div class="card-body">

                  </div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="card">
                  <div class="card-header">Total Por Departamento</div>
                  <div class="card-body">

                  </div>
                </div>
              </div>
              <div class="col-6 col-md-4">
                <div class="card">
                  <div class="card-header">Total Por Facturador</div>
                  <div class="card-body">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.input {
  height: 3rem !important;
  width: 100%;
}
</style>
